export const REPORT_LIMIT_ROWS_1000 = 1000;
export const REPORT_LIMIT_ROWS_3000 = 3000;
